import styled from 'styled-components'

/** Matches invoice detail border-default (~#E4E8EC). */
const borderDefault = '#E4E8EC'

export const StyledStatusTracker = styled.div`
  padding: ${({ theme }) => theme.spacing.sm}rem ${({ theme }) => theme.spacing.md}rem;
  border: 1px solid ${borderDefault};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  background: ${({ theme }) => theme.colors.defaultHover};
`

export const StyledStatusTrackerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
`

export const StyledStatusTrackerHeader = styled.h4`
  color: ${({ theme }) => theme.colors.menuBg};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  font-weight: 600;
  line-height: 1.4;
`

export const StyledTimelineItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

export const StyledTimelineItem = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTimelineRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  align-items: center;
  justify-content: space-between;
`

export const StyledDate = styled.span`
  display: flex;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 500;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.iconGray};
`

export const StyledDetailMessage = styled.div`
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.metalGray};
`

export const StyledMoreButton = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  font-weight: 500;
  line-height: 1.4;
  cursor: pointer;
`

export const StyledProgressIndicator = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  display: block;
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    box-sizing: border-box;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.error};
    border: 1.5px solid ${({ theme }) => theme.colors.error};
    position: absolute;
    left: 0;
    top: 0;
    animation: pulse 3s linear infinite;
  }

  &.completed::after {
    animation: none;
    background: ${({ theme }) => theme.colors.neutralWhite};
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.25;
    }
    100% {
      opacity: 1;
    }
  }
`

export const StyledActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  flex-wrap: wrap;
`

export const StyledStatusTrackerFooter = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  align-items: center;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.iconGray};

  svg {
    width: ${({ theme }) => theme.fontSize.xs}rem;
    height: ${({ theme }) => theme.fontSize.xs}rem;
    flex-shrink: 0;
  }

  a {
    color: ${({ theme }) => theme.colors.iconGray};

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .label {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xxs}rem;

    svg {
      margin-top: -2px;
    }
  }
`
